export default __webpack_public_path__ + "static/media/DIGITALK-LOGO-BRANCO.574f8896.png";